const messages = {
  video: {
    title: 'Immerse yourself in Modern & Contemporary Art with the Centre Pompidou !',
    cta: 'Watch Trailer'
  },
  keypoints: {
    point1: 'An immersion  in a poetic and artistic universe',
    point2: 'Explore the main principles of contemporary art creation',
    point3: 'Navigate through the largest collection of Modern and Contemporary Art in Europe'
  },
  themes: {
    title1: 'Colour and Systems',
    content1: 'In this level, which is divided into two visual systems, you must group the colours across the mirror according to a principle of symmetry.',
    title2: 'Color and Emotion',
    content2: 'A world without colour is a world that cannot exist. Colour every corner of this level to reveal the structure and restore the environment. ',
    title3: 'Light and Physics',
    content3: 'Light can become a physical marker in space. Use your avatar’s light to forge a path and access zones that were previously out of reach. Although the light casts shadows, it also creates paths that turn out to be very real!',
    title4: 'Light and Immersion',
    content4: 'Light can become one body with space. Experiment by playing at the edge of your light and shadow Your movement in the space will create unexpected forms that will eventually reveal, in a perfect layout, a shadow that turns out to be... Your own work!',
    title5: 'Colour and Spirituality ',
    content5: 'Walk through this colourful space filled with abstract forms, where each zone must be activated using the correct object and colour. Try to match them in a way that goes beyond the symbolism of shapes and colour codes.',
    title6: 'Colour and Activism',
    content6: 'In a world resembling a large, dehumanised city, the inhabitants are a resource that allow you to discover certain passages, and the city becomes a large mechanical system to manipulate.',
    title7: 'Colour and Function',
    content7: 'In a work, a colour may have its own function, its own referent. On this level, each colour represents a specific function. Assign a colour to the objects that don’t have one in order to continue.'
  },
  prod: {
    text1: 'Produced thanks to the support of the Ministry of Education and Youth',
    text2: 'A game developed by the Centre Pompidou, Game in Society and Bright, with a soundtrack written specially by Ircam Amplify',
    link: 'Link to Press Release'
  },
  available: {
    date: 'Available Now'
  },
  download: {
    exe: 'Download executable file'
  }
}

export default messages
